import { render, staticRenderFns } from "./gptManageUsers.vue?vue&type=template&id=550138a8&lang=pug"
import script from "./gptManageUsers.vue?vue&type=script&lang=js"
export * from "./gptManageUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports